import script from "./PCMassRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./PCMassRecords.vue?vue&type=script&setup=true&lang=js"

import "./PCMassRecords.vue?vue&type=style&index=0&id=3b0f0a12&lang=scss"

const __exports__ = script;

export default __exports__